/* Street Smart - Steuerung fuer Hintergrundvideos (Play/Pause + Ton)
   Reines Vanilla-JavaScript, keine Bibliotheken. */

(function () {
  if (window.__ssVideoControls) return;
  window.__ssVideoControls = true;

  var STORAGE_KEY = 'ss-video-sound';

  var LABEL = {
    play: 'Video abspielen',
    pause: 'Video pausieren',
    soundOn: 'Ton einschalten',
    soundOff: 'Ton ausschalten'
  };

  function soundWanted() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === 'on';
    } catch (e) {
      return false;
    }
  }

  function rememberSound(on) {
    try {
      sessionStorage.setItem(STORAGE_KEY, on ? 'on' : 'off');
    } catch (e) {
      /* Privater Modus o.ae. - dann eben nur fuer diese Seite. */
    }
  }

  function isVisible(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  function syncPlay(group) {
    var playing = !group.video.paused && !group.video.ended;
    group.playBtn.setAttribute('data-playing', playing ? 'true' : 'false');
    group.playBtn.setAttribute('aria-pressed', playing ? 'false' : 'true');
    group.playBtn.setAttribute('aria-label', playing ? LABEL.pause : LABEL.play);
  }

  function syncSound(group) {
    var muted = group.video.muted;
    group.soundBtn.setAttribute('data-muted', muted ? 'true' : 'false');
    group.soundBtn.setAttribute('aria-pressed', muted ? 'false' : 'true');
    group.soundBtn.setAttribute('aria-label', muted ? LABEL.soundOn : LABEL.soundOff);
  }

  // Ton anschalten. Browser duerfen ein laufendes Video anhalten, sobald es
  // ohne Klick Ton bekommt. Passiert das, gehen wir stumm zurueck, statt ein
  // stehendes Video zu hinterlassen.
  function unmute(group, remember) {
    var video = group.video;
    var wasPlaying = !video.paused;

    video.muted = false;
    if (remember) rememberSound(true);
    syncSound(group);

    // Ein bewusst pausiertes Video soll durch den Ton-Button nicht anlaufen.
    if (!wasPlaying) return;

    var attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(function () {
        video.muted = true;
        if (remember) rememberSound(false);
        var back = video.play();
        if (back && typeof back.catch === 'function') back.catch(function () {});
        syncSound(group);
      });
    }
  }

  function mute(group, remember) {
    group.video.muted = true;
    if (remember) rememberSound(false);
    syncSound(group);
  }

  // Nur das sichtbare Video darf Ton haben. Auf Start- und Passwortseite steht
  // je eine Mobile- und eine Desktop-Fassung im HTML; eine davon ist versteckt.
  function applyStoredSound(group) {
    if (!isVisible(group.el)) {
      if (!group.video.muted) {
        group.video.muted = true;
        syncSound(group);
      }
      return;
    }

    if (!soundWanted()) {
      if (!group.video.muted) mute(group, false);
      return;
    }

    if (!group.video.muted) return;

    // Beim Seitenaufbau laeuft das Video noch nicht. Wuerden wir jetzt schon
    // den Ton anschalten, koennte der Autostart komplett scheitern - also
    // warten wir, bis es tatsaechlich abspielt.
    if (group.video.paused) {
      if (group.pendingUnmute) return;
      group.pendingUnmute = true;
      group.video.addEventListener(
        'playing',
        function () {
          group.pendingUnmute = false;
          if (soundWanted() && isVisible(group.el) && group.video.muted) unmute(group, false);
        },
        { once: true }
      );
      return;
    }

    unmute(group, false);
  }

  var groups = [];

  function bind(el) {
    if (el.getAttribute('data-ss-bound') === '1') return;

    var id = el.getAttribute('data-ss-video-controls');
    var video = document.querySelector('video[data-ss-video="' + id + '"]');
    var playBtn = el.querySelector('[data-ss-play]');
    var soundBtn = el.querySelector('[data-ss-sound]');
    if (!video || !playBtn || !soundBtn) return;

    el.setAttribute('data-ss-bound', '1');

    var group = { el: el, video: video, playBtn: playBtn, soundBtn: soundBtn };
    groups.push(group);

    playBtn.addEventListener('click', function () {
      if (video.paused) {
        var attempt = video.play();
        if (attempt && typeof attempt.catch === 'function') attempt.catch(function () {});
      } else {
        video.pause();
      }
    });

    soundBtn.addEventListener('click', function () {
      if (video.muted) {
        unmute(group, true);
      } else {
        mute(group, true);
      }
    });

    // Icons folgen dem echten Zustand des Videos, auch wenn es von aussen
    // pausiert wird (z. B. weil der Tab in den Hintergrund geht).
    video.addEventListener('play', function () {
      syncPlay(group);
    });
    video.addEventListener('pause', function () {
      syncPlay(group);
    });
    video.addEventListener('volumechange', function () {
      syncSound(group);
    });

    syncPlay(group);
    syncSound(group);
    applyStoredSound(group);
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var found = scope.querySelectorAll('[data-ss-video-controls]');
    for (var i = 0; i < found.length; i++) bind(found[i]);
    watchOverlays();
  }

  function refreshAll() {
    for (var i = 0; i < groups.length; i++) applyStoredSound(groups[i]);
  }

  // Beim Wechsel zwischen Mobil- und Desktopbreite wechselt das sichtbare Video.
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(refreshAll, 200);
  });

  // Gleiche Umschaltbreite wie die Sections selbst.
  if (window.matchMedia) {
    var mq = window.matchMedia('(max-width: 600px)');
    if (mq.addEventListener) {
      mq.addEventListener('change', refreshAll);
    } else if (mq.addListener) {
      mq.addListener(refreshAll);
    }
  }

  // Firefox holt Seiten beim Zurueck-Button aus dem Zwischenspeicher, ohne die
  // Skripte neu zu starten - dann hier den gemerkten Ton nochmal anwenden.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refreshAll();
  });

  // Die Steuerung liegt mit z-index 20 sehr weit oben. Sobald sich irgendein
  // Fenster oder Menue oeffnet (Passwort-Eingabe, Laender-/Waehrungsauswahl,
  // mobiles Menue, Suche), wuerde sie darueber schweben - also ausblenden.
  // Bewusst NICHT enthalten: das Suchfeld selbst, das setzt aria-expanded
  // schon beim Tippen.
  var OVERLAY_SELECTOR = [
    'details.password-modal[open]',
    '.disclosure__button[aria-expanded="true"]',
    'details.menu-drawer-container[open]',
    'details-modal details[open]'
  ].join(',');

  function syncOverlayState() {
    var root = document.documentElement;
    var passwordOpen = !!document.querySelector('details.password-modal[open]');
    root.classList.toggle('ss-overlay-open', !!document.querySelector(OVERLAY_SELECTOR));
    // Eigene Markierung: daran haengt zusaetzlich das Ausblenden des
    // Kopfbereichs, der sonst ueber dem Passwort-Fenster liegt.
    root.classList.toggle('ss-pwmodal-open', passwordOpen);
  }

  var overlaysWatched = false;

  function watchOverlays() {
    syncOverlayState();
    if (overlaysWatched || !window.MutationObserver) return;
    overlaysWatched = true;
    // Ein Beobachter fuer die ganze Seite ist zuverlaessiger als Listener pro
    // Element - "toggle" steigt nicht auf und die Menues werden teils erst
    // spaeter aufgebaut.
    new MutationObserver(syncOverlayState).observe(document.documentElement, {
      subtree: true,
      attributes: true,
      attributeFilter: ['open', 'aria-expanded']
    });
  }

  // Shopify-Theme-Editor laedt Sections neu.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }
})();
